import type { DirectiveCallback } from 'alpinejs'

import { $slider, hasSlider } from './SliderCTX'

type DirectiveParams = Parameters<DirectiveCallback>
export const SliderPart = (
  part: 'gallery' | 'thumbnails',
  el: DirectiveParams[0],
  directive: DirectiveParams[1],
  { Alpine }: DirectiveParams[2],
) => {
  const ctx = Alpine.$data(el)
  if (hasSlider(ctx)) ctx[$slider].components.set(part, el)
  else
    console.error(
      `Element with ${directive.original} needs to be inside an x-slider element`,
      el,
    )
}
